import { createAsyncAction } from "../helpers";

export const getListAsyncAction = createAsyncAction(
	"GET_INSTAGRAM_LIST_REQUEST",
	"GET_INSTAGRAM_LIST_SUCCESS",
	"GET_INSTAGRAM_LIST_FAILURE",
	"GET_INSTAGRAM_LIST_CANCEL"
);

export const postManyAsyncAction = createAsyncAction(
	"POST_INSTAGRAM_MANY_REQUEST",
	"POST_INSTAGRAM_MANY_SUCCESS",
	"POST_INSTAGRAM_MANY_FAILURE",
	"POST_INSTAGRAM_MANY_CANCEL"
);

export const truncateAsyncAction = createAsyncAction(
	"TRUNCATE_INSTAGRAM_REQUEST",
	"TRUNCATE_INSTAGRAM_SUCCESS",
	"TRUNCATE_INSTAGRAM_FAILURE",
	"TRUNCATE_INSTAGRAM_CANCEL"
);
